// extracted by mini-css-extract-plugin
module.exports = {"image":"_6a3fb42"};